document.addEventListener('DOMContentLoaded', function () {
  
      $('#collection-selector, #collection-selector-material, #collection-selector-room, #collection-selector-number').select2({
        minimumResultsForSearch: Infinity,
        width: 'resolve'
      });
    
      $('#collection-selector-material, #collection-selector-room, #collection-selector-number').on('select2:select', function (e) {
        const selectedValue = e.params.data.id;
        const selectedText = e.params.data.text;
        
         filterProducts();
      });

      $('#collection-selector').on('select2:select', function (e) {
        reloadCollectionGrid();
      });

    const select = document.getElementById('collection-selector');
    const grid = document.getElementById('collection-product-grid');
    const materialSelect = document.getElementById('collection-selector-material');
    const lightsSelect = document.getElementById('collection-selector-number');

    function initMasonry() {
      if (window.jQuery && typeof jQuery.fn.masonry === 'function') {
        const $grid = jQuery(grid);
        $grid.imagesLoaded(function () {
          $grid.masonry({
            itemSelector: '.home-collection-product',
            percentPosition: true,
          });
          $grid.masonry('layout');
        });
      }
    }

    initMasonry();


    function reloadCollectionGrid(params = {}) {
      let url = `/collections/${select.value}`;
      const searchParams = new URLSearchParams(params);
      if ([...searchParams].length > 0) {
        url += '?' + searchParams.toString();
      }

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('#collection-product-grid');
          if (newGrid) {
            const currentMaterial = materialSelect.value;
            const currentLights = lightsSelect.value;

            grid.innerHTML = newGrid.innerHTML;

            allProducts.length = 0;
            newGrid.querySelectorAll('.home-collection-product').forEach(p => allProducts.push(p));

            materialSelect.value = currentMaterial;
            lightsSelect.value = currentLights;

            filterProducts();
            updateFilterCounts();
          }
        })
        .catch(err => {
          console.error('Error fetching collection:', err);
        });
    }

    select.addEventListener('change', function () {
      reloadCollectionGrid();
    });

  const allProducts = [];
    grid.querySelectorAll('.home-collection-product').forEach(p => allProducts.push(p));

      materialSelect.addEventListener('change', filterProducts);
      lightsSelect.addEventListener('change', filterProducts);

      function filterProducts() {
        const selectedMaterial = materialSelect.value.toLowerCase();
        const selectedLights = lightsSelect.value;

        grid.classList.add('fade-out');

        setTimeout(() => {
          grid.innerHTML = '';

          allProducts.forEach(product => {
            const productMaterials = (product.getAttribute('data-material') || '').toLowerCase();
            const productLights = parseInt(product.getAttribute('data-lightcount'), 10);

            const materialMatch = selectedMaterial === 'all' || productMaterials.includes(selectedMaterial);
            const lightsMatch = selectedLights === 'all' || (!isNaN(productLights) && productLights >= parseInt(selectedLights, 10));

            if (materialMatch && lightsMatch) {
              grid.appendChild(product);
            }
          });

          if (window.jQuery && typeof jQuery.fn.masonry === 'function') {
            const $grid = jQuery(grid);
            $grid.imagesLoaded(function () {
              $grid.masonry('destroy');
              $grid.masonry({
                itemSelector: '.home-collection-product',
                percentPosition: true,
              });
              $grid.masonry('layout');

              grid.classList.remove('fade-out');
              grid.classList.add('fade-in');

              setTimeout(() => {
                grid.classList.remove('fade-in');
              }, 300);
            });
          } else {
  
            grid.classList.remove('fade-out');
            grid.classList.add('fade-in');
            setTimeout(() => {
              grid.classList.remove('fade-in');
            }, 300);
          }
        }, 150);
      }


      function resizeSelect(select) {
        const temp = document.createElement("span");
        temp.style.position = "absolute";
        temp.style.visibility = "hidden";
        temp.style.height = "auto";
        temp.style.width = "auto";
        temp.style.whiteSpace = "nowrap";
        temp.style.font = getComputedStyle(select).font;
        temp.innerText = select.options[select.selectedIndex].text;

        document.body.appendChild(temp);
        const width = temp.getBoundingClientRect().width;
        select.style.width = `${width + 40}px`;
        document.body.removeChild(temp);
      }

      document.querySelectorAll('.collection-filter--option select').forEach(select => {
        resizeSelect(select);
        select.addEventListener('change', () => resizeSelect(select));
      });

      function updateFilterCounts() {
        
        Array.from(materialSelect.options).forEach(option => {
          if (option.value === 'all') {
            option.textContent = 'any material';
            option.style.display = '';
            return;
          }
          let count = 0;
          allProducts.forEach(product => {
            const productMaterials = (product.getAttribute('data-material') || '').toLowerCase();
            const productLights = parseInt(product.getAttribute('data-lightcount'), 10);

            const lightsMatch = lightsSelect.value === 'all' || (!isNaN(productLights) && productLights >= parseInt(lightsSelect.value, 10));
            const materialMatch = productMaterials.includes(option.value.toLowerCase());

            if (materialMatch && lightsMatch) count++;
          });
          option.textContent = `${option.value}`;
          option.style.display = count > 0 ? '' : 'none';
        });

        
        Array.from(lightsSelect.options).forEach(option => {
          if (option.value === 'all') {
            option.textContent = '0+';
            option.style.display = '';
            return;
          }
          let count = 0;
          allProducts.forEach(product => {
            const productMaterials = (product.getAttribute('data-material') || '').toLowerCase();
            const productLights = parseInt(product.getAttribute('data-lightcount'), 10);

            const materialMatch = materialSelect.value === 'all' || productMaterials.includes(materialSelect.value.toLowerCase());
            const lightsMatch = !isNaN(productLights) && productLights >= parseInt(option.value, 10);

            if (lightsMatch && materialMatch) count++;
          });
          option.textContent = `${option.value}+`;
          option.style.display = count > 0 ? '' : 'none';
        });
      }

      updateFilterCounts();
  });